export default "__VITE_ASSET__DHFxqyPl__"